export default {
  'pages.layouts.userLayout.title': 'Skeleton Admin Management System',
  // Login page
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect username or password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please input your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.captcha.placeholder': 'Captcha',
  'pages.login.captcha.required': 'Please input the captcha!',
  'pages.login.captcha.fetchError': 'Failed to fetch captcha, please retry',
  'pages.login.captcha.notLoaded': 'Captcha not loaded, please refresh',
  'pages.login.captcha.refresh': 'Click to refresh captcha',
  'pages.login.captcha.reload': 'Refresh',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot password?',
  'pages.login.submit': 'Login',
  // Email verification code login
  'pages.login.email.placeholder': 'Enter email address',
  'pages.login.email.required': 'Please enter email address!',
  'pages.login.email.invalid': 'Please enter a valid email address!',
  'pages.login.emailCode.placeholder': 'Enter verification code',
  'pages.login.emailCode.required': 'Please enter verification code!',
  'pages.login.emailCode.send': 'Send Code',
  'pages.login.emailCode.sent': 'Verification code sent',
  'pages.login.emailCode.sendFailed': 'Failed to send code',
  'pages.login.autoRegister': 'Auto-create account for unregistered email',
  'pages.login.emailCaptcha.title': 'Please enter image captcha',
  'pages.login.emailCaptcha.confirm': 'Confirm Send',
  // Agreement consent
  'pages.login.agreement.checkbox':
    'I have read and agree to the Terms of Service and Privacy Policy',
  'pages.login.agreement.termsOfService': 'Terms of Service',
  'pages.login.agreement.privacyPolicy': 'Privacy Policy',
  'pages.login.agreement.required': 'Please agree to the agreements first',
  'pages.login.agreement.modal.title': 'Agreement Consent',
  'pages.login.agreement.modal.content':
    'You need to agree to the following agreements to continue:',
  'pages.login.agreement.modal.submit': 'Agree and Login',
  // Agreement page
  'pages.agreement.title': 'Agreement Details',
  'pages.agreement.effectiveDate': 'Effective Date',
  'pages.agreement.version': 'Version',
  // Welcome page
  'pages.welcome.link': 'Welcome',
  'pages.welcome.alertMessage': 'Welcome to Skeleton Admin Management System.',
  // Error pages
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  'pages.403.subTitle':
    'Sorry, you do not have permission to access this page.',
  'pages.403.buttonText': 'Back Home',
  // Error handling
  'pages.error.appLoadFailed':
    'Application failed to load, please refresh and try again',
  'pages.error.appError': 'Application error, please contact administrator',
  'pages.error.networkError':
    'Network connection failed, please check your network',
  'pages.error.unknownError': 'An unknown error occurred',
  'pages.error.timeout.title': 'Loading Timeout',
  'pages.error.timeout.message':
    'The application is taking too long to load. Please check your network connection and try again.',
  'pages.error.network.title': 'Network Error',
  'pages.error.network.message':
    'Unable to connect to the server. Please check your network connection and try again.',
  'pages.error.loadFailed.title': 'Load Failed',
  'pages.error.loadFailed.message':
    'An error occurred while loading the application. Please try again.',
  'pages.error.permission.title': 'Access Denied',
  'pages.error.permission.message':
    'You do not have permission to access this page. Please contact your administrator.',
  // Sub-app errors
  'pages.subApp.error.title': 'Sub-App Load Failed',
  'pages.subApp.error.description':
    'An error occurred while loading the sub-application. Please try again later.',
  'pages.subApp.error.retry': 'Retry',
  'pages.subApp.error.backHome': 'Back Home',
  'pages.subApp.error.runtimeError': 'Sub-App Runtime Error',
  'pages.subApp.error.runtimeDescription':
    'An uncaught error occurred in the sub-application.',
  // Session
  'pages.session.expired': 'Session expired, please login again',
  'pages.session.loggingOut': 'Logging out...',

  // Forgot Password page
  'pages.forgotPassword.title': 'Forgot Password',
  'pages.forgotPassword.subtitle': 'Reset your password',
  'pages.forgotPassword.phoneTab': 'Phone',
  'pages.forgotPassword.emailTab': 'Email',
  'pages.forgotPassword.phone.placeholder': 'Enter phone number',
  'pages.forgotPassword.phone.required': 'Please enter phone number!',
  'pages.forgotPassword.email.placeholder': 'Enter email address',
  'pages.forgotPassword.email.required': 'Please enter email address!',
  'pages.forgotPassword.email.invalid': 'Please enter a valid email address!',
  'pages.forgotPassword.verifyCode.placeholder': 'Enter verification code',
  'pages.forgotPassword.verifyCode.required': 'Please enter verification code!',
  'pages.forgotPassword.password.placeholder': 'Enter new password',
  'pages.forgotPassword.password.required': 'Please enter new password!',
  'pages.forgotPassword.confirmPassword.placeholder': 'Confirm new password',
  'pages.forgotPassword.confirmPassword.required':
    'Please confirm new password!',
  'pages.forgotPassword.password.mismatch': 'Passwords do not match',
  'pages.forgotPassword.password.min': 'Password must be at least 6 characters',
  'pages.forgotPassword.sendCode': 'Send Code',
  'pages.forgotPassword.submit': 'Reset Password',
  'pages.forgotPassword.success.title': 'Password Reset Successful',
  'pages.forgotPassword.success.desc':
    'Your password has been reset, please login with your new password',
  'pages.forgotPassword.goLogin': 'Go to Login',
  'pages.forgotPassword.code.sent': 'Verification code sent',
  'pages.forgotPassword.code.sendFailed': 'Failed to send code',
  'pages.forgotPassword.verifyId.missing': 'Please get verification code first',
  'pages.forgotPassword.success': 'Password reset successful!',
  'pages.forgotPassword.failed': 'Password reset failed, please try again',
  'pages.forgotPassword.captcha.fetchError':
    'Failed to fetch captcha, please retry',
  'pages.forgotPassword.captcha.required': 'Please enter the captcha!',
  'pages.forgotPassword.captcha.notLoaded':
    'Captcha not loaded, please refresh',
  'pages.forgotPassword.captcha.refresh': 'Click to refresh captcha',
  'pages.forgotPassword.captcha.reload': 'Refresh',
  'pages.forgotPassword.captcha.placeholder': 'Enter captcha',
  'pages.forgotPassword.captchaModal.title': 'Please enter image captcha',
  'pages.forgotPassword.captchaModal.submit': 'Confirm Send',

  // CMS Template
  'cms.template.status.0': 'Disabled',
  'cms.template.status.1': 'Enabled',
  'cms.template.type.RWD': 'Responsive',
  'cms.template.type.PC': 'PC',
  'cms.template.type.MOBILE': 'Mobile',
};
